/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UnblockUserResponse
 */
export interface UnblockUserResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UnblockUserResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof UnblockUserResponse
     */
    message: string;
}

/**
 * Check if a given object implements the UnblockUserResponse interface.
 */
export function instanceOfUnblockUserResponse(value: object): value is UnblockUserResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function UnblockUserResponseFromJSON(json: any): UnblockUserResponse {
    return UnblockUserResponseFromJSONTyped(json, false);
}

export function UnblockUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UnblockUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'message': json['message'],
    };
}

export function UnblockUserResponseToJSON(json: any): UnblockUserResponse {
    return UnblockUserResponseToJSONTyped(json, false);
}

export function UnblockUserResponseToJSONTyped(value?: UnblockUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
    };
}

